
import loginApi from './login/login.api'
import commonApi from '@/axios/common/common.api'
import pythonRunApi from '@/axios/pythonRun/run.api'
 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis


const service_run =
  process.env.NODE_ENV === 'production'
    ? window.gtaAiConfig.service_run
    : '/service_run'
const service_run_gl =
  process.env.NODE_ENV === 'production'
    ? window.gtaAiConfig.service_run_gl
    : '/service_run_gl'
// 路由白名单
const routerWhiteList = ['/', '/login']
// token白名单
const tokenWhiteList = [
  loginApi.login,
  pythonRunApi.serviceRun,
  pythonRunApi.serviceRunGl,
  pythonRunApi.terminateGl,
  `${new_service_basis}/about/abou`,
  `${new_service_basis}/access/isGrant`,
  `${new_service_basis}/online/register`,
]
// tenantId白名单
const tenantIdWhiteList = [
  loginApi.login,
  commonApi.FileInZipCount,
  commonApi.downloadDatesetFile,
  commonApi.UploadFile,
  commonApi.UploadMultipleFile,
  commonApi.UploadImage,
  pythonRunApi.serviceRun,
  pythonRunApi.pjRun,
  pythonRunApi.serviceRunGl,
  pythonRunApi.terminateGl,
  `${new_service_basis}/about/abou`,
  `${new_service_basis}/access/isGrant`,
  `${new_service_basis}/online/register`,
  `${new_service_basis}/ai/training/modelCenter/getModelType`,
  `${new_service_basis}/ai/training/modelCenter/getModelType`,
]
// 请求返回提示白名单
const tipWhiteList = []
// debugger;
export default {
  routerWhiteList,
  tokenWhiteList,
  tipWhiteList,
  // 是否取消路由监听
  routerCancelInterceptor: () => {
    // const { pathname } = window.location;
    // let { hash } = window.location;
    // hash = hash.replace('#', '');
    // if (pathname && !hash) {
    //   return routerWhiteList.includes(pathname);
    // }
    // return routerWhiteList.includes(hash);
  },
  // 是否取消提示语
  tipCancel: (api) => tipWhiteList.includes(api),
  // 是否加载token到请求headers
  tokenCancel: (api) => {
    return tokenWhiteList.includes(api)
  },
  tenantIdCancel: (api) => {
    //所有photoDomain的请求都加入tenantId白名单
    // let photoDomain = window.gtaAiConfig.photoDomain 
    // if (api.test(photoDomain)) {
    //   console.log('photoDomain',photoDomain)
    //   return true
    // } else {
    //   return tenantIdWhiteList.includes(api)
    // }

    return tenantIdWhiteList.includes(api)
  },
}
